import { AxiosPromise } from 'axios';

import api from './api';

const ReportsService = {
  getReportStudents({
    startDate,
    endDate,
    professionalId,
  }: {
    startDate: string;
    endDate: string;
    professionalId: string;
  }): AxiosPromise<any> {
    return api.post(
      '/admin-reports/students',
      {
        startDate,
        endDate,
        professionalId,
      },
      { responseType: 'blob', timeout: 60000 },
    );
  },
  getReportProfessionals(): AxiosPromise<any> {
    return api.get('/admin-reports/professionals', {
      responseType: 'blob',
    });
  },
};

export default ReportsService;
